import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import {
  Rss as FeedIcon,
} from 'react-feather';


const Segment = () => (
  <>
    <Helmet>
      <title>Segment</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <FeedIcon />
        <Box sx={{ pt: 3 }}>

          <Typography paragraph>This is Segment. Coming Soon</Typography>
        </Box>
      </Container>
    </Box>
  </>
);

export default Segment;
